import React, { useState, useRef } from 'react'
import { PrismicLink } from '@prismicio/react'

// Hooks
import useOnClickOutside from '../hooks/useOnClickOutside'

// Components
import ChevronDown from './svg/chevronDown'
import Flag from './flag'

const Dropdown = (props) => {
  const ref = useRef()
  const [isOpen, setOpen] = useState(false)
  const dropdownToggle = () => setOpen(!isOpen)

  useOnClickOutside(ref, () => setOpen(false))
  let columns = 'lg:columns-1'
  if (props.items.length > 20) {
    columns = 'lg:columns-3'
  } else if (props.items.length > 10) {
    columns = 'lg:columns-2'
  }
  return (
    <li ref={ref} className='relative lg:static xl:relative'>
      <button aria-expanded={isOpen} aria-haspopup='true' className={props.navStyles} onClick={dropdownToggle} onKeyDown={dropdownToggle}>
        {props.children.toLowerCase() === 'language' ? (
          <>
            <Flag lang={process.env.GATSBY_COMPANY_URL} />
            <span className='sr-only'>{props.children}</span>
          </>
        ) : (
          props.children
        )}
        <div className='ml-1 text-orange-500'>
          <ChevronDown />
        </div>
      </button>
      <div
        className={`${
          isOpen ? 'z-20 mt-3.5 flex flex-col bg-gray-100 lg:absolute lg:rounded lg:border lg:border-gray-100 lg:bg-white lg:shadow-lg lg:right-0 lg:left-0 xl:left-auto xl:-right-1/2' : 'hidden'
        }`}>
        <ul className={`lg:py-6 ${columns}`}>
          {props.items.map((subNav, index) => {
            return (
              <li className='my-1 whitespace-nowrap' key={`subNav-${index}`}>
                <PrismicLink className={props.subNavStyles} href={subNav.sub_nav_link?.url}>
                  {props.children.toLowerCase() === 'language' && <Flag lang={subNav.sub_nav_link.url} className='mr-2' />} {subNav.sub_nav_link_label}
                </PrismicLink>
              </li>
            )
          })}
        </ul>
      </div>
    </li>
  )
}

export default Dropdown
